import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcEducationWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.25001 6L5.25 22.5C5.25 21.3 6.25 20.5 7.75003 20.5H19.75C22.15 20.5 22.75 18.8333 22.75 18V7C22.75 4.6 21.0834 4 20.25 4H6.75003C5.25 4 5.25 5.5 5.25001 6Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.75 7H18.75V8H8.75V7ZM8.75 9.5H16.75V10.5H8.75V9.5ZM16.75 12H8.75V13H16.75V12Z",
			fill: "#A7C4FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.75 22.5C5.75 21.6716 6.42157 21 7.25 21H20.3358C21.2413 21 22.1097 20.6403 22.75 20V21C22.75 22.6569 21.4069 24 19.75 24H7.25C6.42157 24 5.75 23.3284 5.75 22.5Z",
			fill: "#C4D7FD"
		})
	]
});
export default SvgIcEducationWhite;
